const shouldResetRangeSelection = ({
  clickedDate,
  shouldResetSelection,
  startDate,
  endDate,
}) =>
  Boolean(clickedDate) &&
  (Boolean(shouldResetSelection) || Boolean(startDate && endDate));

export default shouldResetRangeSelection;
